import moment from "moment";


export function identifyFullStory(user) {
    try {
        FS.identify(user.id, {
            displayName: user.member.first_name || '',
            email: user.member.email,
        });
    } catch (e) {
        console.warn(e)
    }
}

// export function fullStoryEvent(event) {
//     try {
//         FS('event', event);
//     } catch (e) {
//         console.warn(e)
//     }
// }
